import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-60">
      {/* NAVBAR FIXED */}
      <Navbar data-id="element-61" />

      {/* CONTENT (SAFE PADDING - ANTI KETUTUP + SUPPORT SHRINK NAVBAR) */}
      <main className="flex-grow pt-[88px] md:pt-[80px] lg:pt-[72px]" data-id="element-62">
        <Outlet data-id="element-63" />
      </main>

      {/* FOOTER */}
      <footer className="bg-pink-50 border-t border-pink-100 mt-16" data-id="element-64">
        <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-65">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-sm" data-id="element-66">
            {/* BRAND */}
            <div className="space-y-3" data-id="element-67">
              <div className="flex items-center gap-3" data-id="element-68">
                <img src="https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/igi%20-%204.png" alt="logo" className="w-9 h-9 rounded-lg" data-id="element-69" />
                <span className="font-semibold text-gray-800" data-id="element-70">Digicouns</span>
              </div>

              <p className="text-gray-500 leading-relaxed" data-id="element-71">
                Platform layanan bimbingan dan konseling digital untuk membantu
                perkembangan siswa secara pribadi, sosial, akademik, dan karier.
              </p>
            </div>

            {/* LAYANAN */}
            <div data-id="element-72">
              <h3 className="font-semibold text-gray-800 mb-4" data-id="element-73">Layanan</h3>

              <ul className="space-y-2 text-gray-500" data-id="element-74">
                <li data-id="element-75">
                  <a href="/bimbingan" className="hover:text-pink-500" data-id="element-76">
                    Bimbingan
                  </a>
                </li>
                <li data-id="element-77">
                  <a href="/konseling" className="hover:text-pink-500" data-id="element-78">
                    Konseling
                  </a>
                </li>
                <li data-id="element-79">
                  <a href="/edukasi" className="hover:text-pink-500" data-id="element-80">
                    Edukasi
                  </a>
                </li>
                <li data-id="element-81">
                  <a href="/orang-tua" className="hover:text-pink-500" data-id="element-82">
                    Orang tua
                  </a>
                </li>
                <li data-id="element-83">
                  <a href="/asesmen" className="hover:text-pink-500" data-id="element-84">
                    Asesmen
                  </a>
                </li>
                <li data-id="element-85">
                  <a href="/jurnal" className="hover:text-pink-500" data-id="element-86">
                    Jurnal
                  </a>
                </li>
                <li data-id="element-87">
                  <a href="/rate-us" className="hover:text-pink-500" data-id="element-88">
                    Rate Us
                  </a>
                </li>
                <li data-id="element-89">
                  <a href="/laporan-admin" className="hover:text-pink-500" data-id="element-90">
                    Laporan Admin
                  </a>
                </li>
              </ul>
            </div>

            {/* TENTANG */}
            <div data-id="element-91">
              <h3 className="font-semibold text-gray-800 mb-4" data-id="element-92">Tentang</h3>

              <ul className="space-y-2 text-gray-500" data-id="element-93">
                <li data-id="element-94">Nama: Meita Sulistiyo (2400751)</li>
                <li data-id="element-95">Universitas Pendidikan Indonesia</li>
                <li data-id="element-96">
                  <a href="https://wa.me/6285713695535" target="_blank" rel="noopener noreferrer" className="hover:text-green-500" data-id="element-97">
                    WhatsApp: 0857-1369-5535
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* COPYRIGHT */}
          <div className="mt-10 border-t border-pink-100 pt-6 text-center text-xs text-gray-400" data-id="element-98">
            © {new Date().getFullYear()} Digicouns. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}